"use client";

import { ColorPicker } from "@/components/atoms/colorpicker";
import type { InlineEditorProps } from "../types";

/**
 * Inline editor component for editing table headers/cells
 */
const InlineEditor = ({
  name,
  textColor,
  bgColor,
  borderColor,
  onNameChange,
  onTextColorChange,
  onBgColorChange,
  onBorderColorChange,
  onSave,
  onCancel,
  placeholder = "Enter name",
  defaultTextColor = "#000000",
  defaultBgColor = "#ffffff",
  defaultBorderColor = "#e2e8f0",
  showTextColor = true,
  showBgColor = true,
  showBorderColor = true,
}: InlineEditorProps) => {
  return (
    <div
      className="flex flex-col gap-2 p-2 bg-white rounded shadow-lg border min-w-[220px]"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Name Input */}
      <input
        type="text"
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        placeholder={placeholder}
        className="w-full px-2 py-1 border border-gray-300 rounded text-sm text-gray-900"
        autoFocus
        onKeyDown={(e) => {
          if (e.key === "Enter") onSave();
          if (e.key === "Escape") onCancel();
        }}
      />

      {/* Color Inputs */}
      <div className="flex flex-col gap-1">
        {showTextColor && (
          <ColorPicker
            label="Text"
            value={textColor}
            onChange={onTextColorChange}
            defaultColor={defaultTextColor}
          />
        )}
        {showBgColor && (
          <ColorPicker
            label="BG"
            value={bgColor}
            onChange={onBgColorChange}
            defaultColor={defaultBgColor}
          />
        )}
        {showBorderColor && (
          <ColorPicker
            label="Border"
            value={borderColor}
            onChange={onBorderColorChange}
            defaultColor={defaultBorderColor}
          />
        )}
      </div>

      {/* Action Buttons */}
      <div className="flex justify-center gap-1 pt-1">
        <button
          onClick={onSave}
          className="px-2 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700"
        >
          Save
        </button>
        <button
          onClick={onCancel}
          className="px-2 py-1 text-xs bg-gray-400 text-white rounded hover:bg-gray-500"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default InlineEditor;
